/* MV Sortiment assets/mv-sortiment.kalkulator.js - Agent T-B - 2026-10-02
 *
 * Vorbelegung des Automaten-Kalkulators (/pages/automaten-kalkulator, templates/page.kalkulator.json,
 * sections/snackautomat-roi-rechner.liquid + assets/snackautomat-roi-rechner.js) aus URL-Parametern,
 * die der Rechner-Teaser (T-D, mv-rechner-teaser) und der Finder (T-F) anhaengen. Teil von
 * assets/mv-sortiment.js, laedt allein und in beliebiger Reihenfolge; der Rechner selbst bleibt unveraendert.
 *
 *   preis      Kaufpreis netto in EUR   -> [data-roi-field="purchasePriceNet"] (Schritt 3, Kaufen)
 *   verkaeufe  Verkaeufe pro Tag        -> Direktmodus [data-roi-field="manualUnitsMode"] an,
 *                                          [data-roi-field="manualUnitsPerDay"]
 *   bon        Durchschnittsbon in EUR  -> VK brutto ([data-cat-field="grossSellingPrice"]) aller aktiven
 *                                          Sortimentskategorien proportional skaliert, bis der nach Mix-Anteil
 *                                          gewichtete Durchschnitt dem Bon entspricht (Verkaeufe x Bon =
 *                                          Umsatz brutto wie im Teaser)
 *   marge      Marge in Prozent         -> EK netto je aktiver Kategorie ([data-cat-field="purchasePriceNet"])
 *                                          = VK netto x (1 - Marge/100), VK netto = VK brutto / (1 + MwSt./100);
 *                                          entspricht der Rohertragsmarge, die der Rechner ausweist
 *
 * Ablauf: einmalig je Seitenaufruf und nur mit gueltigen Parametern, erst nachdem der Rechner initialisiert
 * ist (er setzt data-roi-initialized="true" und ueberschreibt danach seine Felder mit Standardwerten).
 * Danach genau ein change-Ereignis (bubbles) an einem gesetzten Feld: der change-Listener des Rechners
 * schaltet die Bereiche um (Direktmodus) und rechnet neu. Bewusst kein input-Ereignis, weil der Rechner beim
 * ersten input "calculator_started" an window und dataLayer meldet und die Vorbelegung keine Nutzeraktion ist.
 * Kommentare ASCII.
 *
 * Nachtrag A-2a (2026-10-10, _docs/a2a-konto-speicherschicht.md): Eingaben speichern und wiederherstellen ueber MVKonto
 * (assets/mv-sortiment.konto.js), Werkzeug-Schluessel "kalkulator". Stand { v: 1, titel (Text der Standortwahl),
 * felder (alle [data-roi-field] ausser im Anfrageformular; doppelte Namen wie setupCost als setupCost~2 in
 * DOM-Reihenfolge), profile (Sortiment, Zahlung, Betrieb), kategorien (je Zeile mit Name, ohne den Namen zu setzen) }.
 * Ablauf nach der Initialisierung des Rechners: (1) Stand aus dem Browser-Spiegel (MVKonto.lokal) in die Felder, ein
 * change-Ereignis an der Sektion selbst (der Rechner rechnet neu, keine Profil- oder Standortvorgaben, die an Feldern
 * haengen); (2) Vorbelegung aus der Adresse wie bisher, darueber; (3) Statuszeile [data-mv-konto-hinweis]; mit Login
 * ohne Adress-Parameter der Konto-Stand, wenn er abweicht und noch nichts geaendert wurde (sonst gilt die Eingabe und
 * geht wieder in den Spiegel). Danach speichert jede Eingabe (input, change) den ganzen Stand; die Vorbelegung allein
 * speichert nichts (keine Nutzeraktion). Ohne MVKonto und ohne Parameter passiert wie bisher nichts. Keine
 * Personendaten: das Anfrageformular bleibt aussen vor.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-10.1';

  // Plausible Bereiche je Parameter (ausserhalb: Parameter wird ignoriert)
  var GRENZEN = {
    preis: [1, 1000000],
    verkaeufe: [0, 5000],
    bon: [0.05, 1000],
    marge: [0, 99]
  };

  var FELDER = {
    preis: '[data-roi-field="purchasePriceNet"]',
    direktmodus: '[data-roi-field="manualUnitsMode"]',
    verkaeufe: '[data-roi-field="manualUnitsPerDay"]',
    kategorie: '[data-roi-category]',
    aktiv: '[data-cat-field="enabled"]',
    anteil: '[data-cat-field="mixShare"]',
    vkBrutto: '[data-cat-field="grossSellingPrice"]',
    ekNetto: '[data-cat-field="purchasePriceNet"]',
    mwst: '[data-cat-field="vatRate"]'
  };

  // Deutsche und englische Schreibweise: "2,50", "2.5", "1.234,5", "6.350", " 40 % ", "5900 EUR-Zeichen"
  function zahl(wert) {
    if (typeof wert === 'number') return isFinite(wert) ? wert : NaN;
    if (wert === null || wert === undefined) return NaN;
    var s = String(wert).replace(/[\s%\u20ac\u00a0]/g, '');
    if (!s) return NaN;
    if (s.indexOf(',') !== -1) s = s.replace(/\./g, '').replace(',', '.');
    else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, '');
    if (!/^-?\d+(\.\d+)?$/.test(s)) return NaN;
    return parseFloat(s);
  }

  function runde2(x) {
    return Math.round(x * 100) / 100;
  }

  function dekodiere(t) {
    try {
      return decodeURIComponent(String(t).replace(/\+/g, ' '));
    } catch (e) {
      return null;
    }
  }

  // "?preis=6350&bon=2.5" -> { preis: 6350, bon: 2.5 }; erster Wert je Name gewinnt
  function parameter(suche) {
    var ergebnis = {};
    var s = String(suche || '');
    if (s.charAt(0) === '?') s = s.slice(1);
    s.split('&').forEach(function (teil) {
      if (!teil) return;
      var i = teil.indexOf('=');
      var name = dekodiere(i === -1 ? teil : teil.slice(0, i));
      var roh = dekodiere(i === -1 ? '' : teil.slice(i + 1));
      if (name === null || roh === null) return;
      if (!Object.prototype.hasOwnProperty.call(GRENZEN, name) || Object.prototype.hasOwnProperty.call(ergebnis, name)) return;
      var n = zahl(roh);
      var g = GRENZEN[name];
      if (isFinite(n) && n >= g[0] && n <= g[1]) ergebnis[name] = runde2(n);
    });
    return ergebnis;
  }

  function nichtNegativ(x) {
    var n = zahl(x);
    return isFinite(n) && n > 0 ? n : 0;
  }

  // kategorien: [{aktiv, anteil, vkBrutto, ekNetto, mwst}] -> neue Liste gleicher Laenge
  function kategorienAnpassen(kategorien, werte) {
    werte = werte || {};
    var liste = (kategorien || []).map(function (k) {
      return {
        aktiv: k.aktiv !== false,
        anteil: nichtNegativ(k.anteil),
        vkBrutto: nichtNegativ(k.vkBrutto),
        ekNetto: nichtNegativ(k.ekNetto),
        mwst: nichtNegativ(k.mwst)
      };
    });
    if (werte.bon !== undefined) {
      var gewicht = 0;
      var summe = 0;
      liste.forEach(function (k) {
        if (k.aktiv && k.anteil > 0) {
          gewicht += k.anteil;
          summe += k.anteil * k.vkBrutto;
        }
      });
      var schnitt = gewicht > 0 ? summe / gewicht : 0;
      liste.forEach(function (k) {
        if (!k.aktiv) return;
        if (schnitt > 0) k.vkBrutto = runde2(k.vkBrutto * werte.bon / schnitt);
        else if (gewicht > 0) k.vkBrutto = runde2(werte.bon);
      });
    }
    if (werte.marge !== undefined) {
      liste.forEach(function (k) {
        if (!k.aktiv) return;
        k.ekNetto = runde2(k.vkBrutto / (1 + k.mwst / 100) * (1 - werte.marge / 100));
      });
    }
    return liste;
  }

  // ------------------------------------------------------------------ Konto (Paket A-2a)

  var KONTO_WERKZEUG = 'kalkulator';
  var PROFILE = { sortiment: 'data-roi-assortment-profile', zahlung: 'data-roi-payment-profile', betrieb: 'data-roi-operation-profile' };
  var KAT_FELDER = ['enabled', 'mixShare', 'grossSellingPrice', 'purchasePriceNet', 'vatRate', 'wasteRate', 'shrinkageRate'];
  var FELD_NAME = /^[A-Za-z][A-Za-z0-9]{0,40}(?:~[0-9]{1,2})?$/;

  function hat(o, k) {
    return !!o && Object.prototype.hasOwnProperty.call(o, k);
  }

  // ["a", "b", "a"] -> ["a", "b", "a~2"]: doppelte Feldnamen (setupCost bei Kauf und Leasing) in DOM-Reihenfolge
  function schluesselListe(namen) {
    var zaehler = {};
    return (namen || []).map(function (n) {
      var name = String(n);
      zaehler[name] = (zaehler[name] || 0) + 1;
      return zaehler[name] > 1 ? name + '~' + zaehler[name] : name;
    });
  }

  function wertOk(v) {
    return typeof v === 'boolean' || (typeof v === 'string' && v.length <= 200);
  }

  // Stand aus dem Konto oder Browser robust lesen; unbekannte Teile fallen weg, sonst null
  function kontoStandPruefen(stand) {
    if (!stand || typeof stand !== 'object' || stand.v !== 1) return null;
    var aus = { v: 1, felder: {}, profile: {}, kategorien: [] };
    var f = stand.felder && typeof stand.felder === 'object' ? stand.felder : {};
    Object.keys(f).forEach(function (k) {
      if (FELD_NAME.test(k) && wertOk(f[k])) aus.felder[k] = f[k];
    });
    var p = stand.profile && typeof stand.profile === 'object' ? stand.profile : {};
    Object.keys(PROFILE).forEach(function (k) {
      if (hat(p, k) && typeof p[k] === 'string' && p[k].length <= 200) aus.profile[k] = p[k];
    });
    if (Object.prototype.toString.call(stand.kategorien) === '[object Array]') {
      stand.kategorien.slice(0, 50).forEach(function (z) {
        if (!z || typeof z !== 'object') return;
        var o = { name: typeof z.name === 'string' ? z.name.slice(0, 200) : '' };
        KAT_FELDER.forEach(function (feld) {
          if (hat(z, feld) && wertOk(z[feld])) o[feld] = z[feld];
        });
        aus.kategorien.push(o);
      });
    }
    if (typeof stand.titel === 'string' && stand.titel) aus.titel = stand.titel.slice(0, 120);
    return aus;
  }

  var logik = {
    VERSION: VERSION, GRENZEN: GRENZEN, FELDER: FELDER, zahl: zahl, parameter: parameter, kategorienAnpassen: kategorienAnpassen,
    KONTO_WERKZEUG: KONTO_WERKZEUG, PROFILE: PROFILE, KAT_FELDER: KAT_FELDER, schluesselListe: schluesselListe, kontoStandPruefen: kontoStandPruefen
  };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.kalkulator) return;

  var WARTEZEIT_MS = 5000;

  // Gibt das zuletzt geaenderte Feld zurueck (Ziel des change-Ereignisses) oder null
  function befuelle(sektion, werte) {
    if (sektion.getAttribute('data-mv-kalkulator-vorbelegt') === 'true') return null;
    sektion.setAttribute('data-mv-kalkulator-vorbelegt', 'true');
    var geaendert = [];
    var schalter = null;

    function setze(el, wert) {
      if (!el) return;
      var t = String(wert);
      if (el.value !== t) {
        el.value = t;
        geaendert.push(el);
      }
    }

    if (werte.preis !== undefined) setze(sektion.querySelector(FELDER.preis), werte.preis);
    if (werte.verkaeufe !== undefined) {
      var modus = sektion.querySelector(FELDER.direktmodus);
      if (modus && !modus.checked) {
        modus.checked = true;
        schalter = modus;
      }
      setze(sektion.querySelector(FELDER.verkaeufe), werte.verkaeufe);
    }
    if (werte.bon !== undefined || werte.marge !== undefined) {
      var zeilen = Array.prototype.slice.call(sektion.querySelectorAll(FELDER.kategorie));
      var neu = kategorienAnpassen(zeilen.map(function (z) {
        var aktiv = z.querySelector(FELDER.aktiv);
        var feld = function (sel) {
          var el = z.querySelector(sel);
          return el ? el.value : '';
        };
        return { aktiv: aktiv ? aktiv.checked : true, anteil: feld(FELDER.anteil), vkBrutto: feld(FELDER.vkBrutto), ekNetto: feld(FELDER.ekNetto), mwst: feld(FELDER.mwst) };
      }), werte);
      zeilen.forEach(function (z, i) {
        if (!neu[i].aktiv) return;
        if (werte.bon !== undefined) setze(z.querySelector(FELDER.vkBrutto), neu[i].vkBrutto);
        if (werte.marge !== undefined) setze(z.querySelector(FELDER.ekNetto), neu[i].ekNetto);
      });
    }

    var ziel = schalter || geaendert[geaendert.length - 1] || null;
    if (ziel) ziel.dispatchEvent(new Event('change', { bubbles: true }));
    return ziel;
  }

  // fn einmal, sobald der Rechner initialisiert ist (er setzt data-roi-initialized="true" und danach seine
  // Standardwerte; der MutationObserver meldet als Mikrotask nach initCalculator, dann stehen die Standardwerte)
  function nachInit(sektion, fn) {
    if (sektion.getAttribute('data-roi-initialized') === 'true') {
      fn();
      return;
    }
    var erledigt = false;
    var beobachter = null;
    function pruefe() {
      if (erledigt || sektion.getAttribute('data-roi-initialized') !== 'true') return;
      erledigt = true;
      if (beobachter) beobachter.disconnect();
      fn();
    }
    if (typeof window.MutationObserver === 'function') {
      // wartet ohne Frist; ohne Rechner-Skript passiert nie etwas (nichts zu rechnen)
      beobachter = new window.MutationObserver(pruefe);
      beobachter.observe(sektion, { attributes: true, attributeFilter: ['data-roi-initialized'] });
      return;
    }
    // Rueckfall ohne MutationObserver: einmal spaet pruefen
    window.setTimeout(pruefe, WARTEZEIT_MS);
  }

  // ---------------------------------------------------------------- Konto (Paket A-2a)

  // Konto-Schicht (assets/mv-sortiment.konto.js); im Buendel nach dieser Datei, darum erst beim Aufruf
  function konto() {
    var k = window.MVKonto;
    return k && typeof k.speichern === 'function' && typeof k.lesen === 'function' ? k : null;
  }

  // [data-roi-field] der Sektion ohne das Anfrageformular (Name, E-Mail und Telefon werden nie gespeichert)
  function steuerelemente(sektion) {
    return Array.prototype.filter.call(sektion.querySelectorAll('[data-roi-field]'), function (el) {
      return !(el.closest && el.closest('.snack-roi__lead-form'));
    });
  }

  function wertVon(el) {
    return el.type === 'checkbox' ? !!el.checked : String(el.value);
  }

  function standVon(sektion) {
    var els = steuerelemente(sektion);
    var namen = schluesselListe(els.map(function (el) { return el.getAttribute('data-roi-field'); }));
    var felder = {};
    els.forEach(function (el, i) { felder[namen[i]] = wertVon(el); });
    var profile = {};
    Object.keys(PROFILE).forEach(function (k) {
      var el = sektion.querySelector('[' + PROFILE[k] + ']');
      if (el) profile[k] = String(el.value);
    });
    var kategorien = Array.prototype.map.call(sektion.querySelectorAll(FELDER.kategorie), function (z) {
      var name = z.querySelector('[data-cat-field="name"]');
      var o = { name: name ? String(name.value) : '' };
      KAT_FELDER.forEach(function (f) {
        var el = z.querySelector('[data-cat-field="' + f + '"]');
        if (el) o[f] = wertVon(el);
      });
      return o;
    });
    var s = { v: 1, felder: felder, profile: profile, kategorien: kategorien };
    var typ = sektion.querySelector('[data-roi-field="locationType"]');
    var titel = typ && typ.options && typ.selectedIndex >= 0 ? String(typ.options[typ.selectedIndex].text || '').replace(/\s+/g, ' ').replace(/^ | $/g, '') : '';
    if (titel) s.titel = titel;
    return s;
  }

  // Wert setzen ohne Ereignis; Auswahlfelder nur mit einer vorhandenen Option. true, wenn sich etwas aendert
  function setzeWert(el, v) {
    if (el.type === 'checkbox') {
      var an = v === true;
      if (el.checked === an) return false;
      el.checked = an;
      return true;
    }
    if (typeof v !== 'string') return false;
    if (el.tagName === 'SELECT') {
      var da = false;
      for (var i = 0; i < el.options.length; i++) if (el.options[i].value === v) da = true;
      if (!da) return false;
    }
    if (el.value === v) return false;
    el.value = v;
    return true;
  }

  function anwendenStand(sektion, stand) {
    var s = kontoStandPruefen(stand);
    if (!s) return false;
    var geaendert = false;
    Object.keys(PROFILE).forEach(function (k) {
      var el = hat(s.profile, k) ? sektion.querySelector('[' + PROFILE[k] + ']') : null;
      if (el && setzeWert(el, s.profile[k])) geaendert = true;
    });
    var els = steuerelemente(sektion);
    var namen = schluesselListe(els.map(function (el) { return el.getAttribute('data-roi-field'); }));
    els.forEach(function (el, i) {
      if (hat(s.felder, namen[i]) && setzeWert(el, s.felder[namen[i]])) geaendert = true;
    });
    // Kategorien ueber ihren Namen (Bloecke der Sektion; eine umbenannte Kategorie behaelt ihre Vorgaben)
    Array.prototype.forEach.call(sektion.querySelectorAll(FELDER.kategorie), function (z) {
      var nameEl = z.querySelector('[data-cat-field="name"]');
      var name = nameEl ? String(nameEl.value) : '';
      var k = null;
      for (var j = 0; j < s.kategorien.length && name; j++) if (s.kategorien[j].name === name) k = s.kategorien[j];
      if (!k) return;
      KAT_FELDER.forEach(function (f) {
        var el = hat(k, f) ? z.querySelector('[data-cat-field="' + f + '"]') : null;
        if (el && setzeWert(el, k[f])) geaendert = true;
      });
    });
    return geaendert;
  }

  // Ein change-Ereignis an der Sektion selbst: der Rechner schaltet Bereiche und rechnet neu; Standort-, Profil- und
  // Kostenvorgaben haengen am Feld als Ziel und bleiben aus. Eigene Speicherung waehrenddessen aus.
  function stoss(sektion) {
    sektion.__mvKalkStill = true;
    try {
      sektion.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      sektion.__mvKalkStill = false;
    }
  }

  function wiederherstellen(sektion, mv) {
    if (typeof mv.lokal !== 'function') return false;
    var e = null;
    try { e = mv.lokal(KONTO_WERKZEUG); } catch (f) { e = null; }
    if (!e || !e.stand || !anwendenStand(sektion, e.stand)) return false;
    stoss(sektion);
    return true;
  }

  function binden(sektion, mv, mitWerten) {
    if (sektion.__mvKalkKonto) return;
    var merker = { text: JSON.stringify(standVon(sektion)) };
    sektion.__mvKalkKonto = merker;
    var box = sektion.querySelector('[data-mv-konto-hinweis]');
    if (box && typeof mv.hinweis === 'function') mv.hinweis(box, KONTO_WERKZEUG);
    // Mit Adress-Parametern gilt die Vorbelegung dieses Besuchs; sonst mit Login der Konto-Stand, wenn er abweicht
    if (mitWerten || typeof mv.eingeloggt !== 'function' || !mv.eingeloggt()) return;
    var vorher = merker.text;
    mv.lesen(KONTO_WERKZEUG).then(function (r) {
      if (!r || !r.neu || !r.stand) return;
      // Schon eingegeben (Konto-Stand trotzdem uebernommen, weil die Geraeteuhr nachgeht): die Eingabe gilt, der Spiegel
      // bekommt wieder den Stand der Seite
      if (merker.text !== vorher) {
        mv.speichern(KONTO_WERKZEUG, standVon(sektion));
        return;
      }
      if (anwendenStand(sektion, r.stand)) stoss(sektion);
      merker.text = JSON.stringify(standVon(sektion));
    }, function () { /* Konto nicht erreichbar: der Browser-Stand bleibt */ });
  }

  // Jede Eingabe in einer gebundenen Sektion speichert den ganzen Stand (nur wenn er sich geaendert hat); das
  // Anfrageformular gehoert nie zum Stand (steuerelemente), Eingaben dort aendern ihn also nicht
  function beiEingabe(e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var sektion = t.closest('[data-snack-roi-calculator]');
    if (!sektion || !sektion.__mvKalkKonto || sektion.__mvKalkStill) return;
    var mv = konto();
    if (!mv) return;
    var s = standVon(sektion);
    var text = JSON.stringify(s);
    if (text === sektion.__mvKalkKonto.text) return;
    sektion.__mvKalkKonto.text = text;
    mv.speichern(KONTO_WERKZEUG, s);
  }

  document.addEventListener('input', beiEingabe);
  document.addEventListener('change', beiEingabe);

  function start() {
    var werte = parameter(window.location.search);
    var mitWerten = Object.keys(werte).length > 0;
    var mv = konto();
    // ohne Parameter und ohne Konto-Schicht passiert wie bisher nichts
    if (!mitWerten && !mv) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-snack-roi-calculator]'), function (sektion) {
      nachInit(sektion, function () {
        if (mv) wiederherstellen(sektion, mv);
        if (mitWerten) befuelle(sektion, werte);
        if (mv) binden(sektion, mv, mitWerten);
      });
    });
  }

  MV.kalkulator = { version: VERSION, logik: logik, befuelle: befuelle, stand: standVon, anwenden: anwendenStand };

  // A-2a: MVKonto steht im Buendel nach dieser Datei (konkat.sh, alphabetisch): erst nach dem Buendel starten
  function nachBuendel(fn) {
    if (window.MVKonto || typeof window.Promise !== 'function') fn();
    else window.Promise.resolve().then(fn);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { nachBuendel(start); });
  else nachBuendel(start);
})();
